import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./core/guards/auth.guard";
import { PageNotFoundComponent } from "./layouts/page-not-found/page-not-found.component";
import { AuthComponent } from "./public/auth/auth.component";

const routes: Routes = [
  {
    path: "auth",
    component: AuthComponent,
  },
  {
    path: "sku",
    canActivate: [AuthGuard],
    loadChildren: () => import("./features/sku/sku.module").then(m => m.SkuModule),
  },
  {
    path: "models",
    canActivate: [AuthGuard],
    loadChildren: () => import("./features/models/models.module").then(m => m.ModelsModule),
  },
  {
    path: "materials",
    canActivate: [AuthGuard],
    loadChildren: () => import("./features/materials/materials.module").then(m => m.MaterialsModule),
  },
  {
    path: "venues",
    canActivate: [AuthGuard],
    loadChildren: () => import("./features/venues/venues.module").then(m => m.VenuesModule),
  },
  {
    path: "vendors",
    canActivate: [AuthGuard],
    loadChildren: () => import("./features/vendors/vendors.module").then(m => m.VendorsModule),
  },
  {
    path: "taxonomy",
    canActivate: [AuthGuard],
    loadChildren: () => import("./features/taxonomy/taxonomy.module").then(m => m.TaxonomyModule),
  },
  {
    path: "sketch-tool",
    canActivate: [AuthGuard],
    loadChildren: () => import("./features/sketch-tool/sketch-tool.module").then(m => m.SketchToolModule),
  },
  {
    path: "",
    redirectTo: "sku",
    pathMatch: "full",
  },
  {
    path: "**",
    canActivate: [AuthGuard],
    component: PageNotFoundComponent,
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      onSameUrlNavigation: "reload",
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
